import { FULL_HD, HD, safetyMargins } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { middle, SCREEN_HEIGHT, SCREEN_WIDTH } from '../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const GAP = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const TEXT_GAP = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const LOGO_HEIGHT = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const getWordWrapWidth = screenSize => Math.round(SCREEN_WIDTH[screenSize] * 0.75);

export const colors = {
  text: makeThemeColor(PRIMARY),
  background: makeThemeColor(TERTIARY),
};

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => {
  const w = SCREEN_WIDTH[screenSize];
  const h = SCREEN_HEIGHT[screenSize];
  const textColor = colors.text[colorMode];
  const wordWrapWidth = getWordWrapWidth(screenSize);

  return {
    w,
    h,
    color: colors.background,
    Background: {
      w,
      h,
    },
    Logo: {
      mountX: 0.5,
      x: middle,
      y: safetyMargins.vertical[screenSize],
      h: LOGO_HEIGHT[screenSize],
    },
    Container: {
      w,
      h,
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
      Title: {
        text: {
          ...getFont(FONT.KINSHASA_3),
          textColor,
          wordWrapWidth,
          textAlign: 'center',
          maxLines: 2,
        },
        flexItem: {
          marginBottom: TEXT_GAP[screenSize],
        },
      },
      Description: {
        text: {
          ...getFont(FONT.OTTAWA_1),
          textColor,
          wordWrapWidth,
          textAlign: 'center',
          maxLines: 5,
        },
        flexItem: {
          marginBottom: TEXT_GAP[screenSize],
        },
      },
      Buttons: {
        flex: { direction: 'row' },
        flexItem: {
          marginTop: GAP[screenSize],
          marginBottom: GAP[screenSize],
        },
        Retry: {
          flexItem: {
            marginRight: GAP[screenSize],
          },
        },
        Logout: {},
      },
    },
  };
};
